<template>
  <slo-button fill="clear" @click="addToDesignSpec()" class="p-0">
    <SloIcon name="FolderOpen" />
    <span>
      <slot>{{ 'Add to DesignSpec' | t }}</slot>
    </span>
  </slo-button>
</template>

<script>
import {mapState} from 'vuex';
import t from '../../main/i18n';
import SloButton from '../../../lib/components/SloButton.vue';
import SloIcon from '../../../lib/components/SloIcon.vue';

export default {
  components: {
    SloIcon,
    SloButton
  },
  filters: {
    t
  },
  props: {
    /* product | variation */
    type: {type: String, required: true},
    itemId: {type: [Number, String], required: true},
    itemThumbnail: {type: String}
  },
  computed: mapState('designspec', ['projects']),
  methods: {
    addToDesignSpec() {
      const params = {
        type: this.type,
        id: this.itemId,
        thumbnail: this.itemThumbnail
      };

      const useSrc =
        params.thumbnail &&
        (params.thumbnail.indexOf('/') === 0 || params.thumbnail.indexOf('http') === 0);
      const thumbnail = useSrc
        ? `<img src="${params.thumbnail}" style="width:152px;height:152px;margin:auto 0;" width="152" height="152">`
        : `<div style="width:152px;height:152px;margin:auto 0;">${params.thumbnail}</div>`;

      if (this.projects.length === 0) {
        this.$modal.show({
          name: 'DesignSpecCreateProject',
          onCreate: projectId => {
            this.$modal.show(
              Object.assign({name: 'DesignSpecAddToProject'}, params, {
                projectId
              })
            );
          }
        });
      } else {
        this.$modal.show(
          Object.assign({name: 'DesignSpecAddToProject'}, params, {
            onAdd: opts => {
              const toast = this.$snotify.html(
                `<div style="display:flex;">
                  <div class="overlay">
                    <button class="icon" data-dismiss="">
                      <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"/></svg>
                    </button>
                  </div>
                  ${thumbnail}
                  <div style="flex:1 1 auto;margin-left:8px;display:flex;flex-direction:column;align-items:space-between;padding:8px;">
                    <p class="message" style="color:#006BB6;"><svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"></path></svg>${t('Added to DesignSpec')}</a>
                    <p>${opts.product || t('Product') + ' ' + t('has been added to')} <strong>${opts.name}</strong></p>
                    <a href="${opts.url}" style="color:#006BB6;">${t('Open in DesignSpec')}</a>
                  </div>
                </div>`
              );

              toast.on('click', t => {
                if (
                  event.target &&
                  typeof event.target.dataset.dismiss !== 'undefined'
                ) {
                  this.$snotify.remove(t.id);
                } else {
                  window.location = opts.url;
                }
              });
            }
          })
        );
      }
    }
  }
};
</script>
